import { Route, Routes } from 'react-router-dom';
import ResetPassword from 'pages/login/ResetPassword';
import Login from 'pages/Login';
import ForgotPassword from 'pages/login/ForgotPassword';
import SignupRoute from 'routes/SignupRoute';

const LoginRoutes = () => (
  <Routes>
    <Route element={<SignupRoute />}>
      {['/', '/login'].map(path => (
        <Route key={path} path={path} element={<Login />} />
      ))}
      <Route
        path="forgot-password"
        shouldRedirectIfLoggedIn={false}
        element={<ForgotPassword />}
      />
      <Route path="reset-password/:resetCode" element={<ResetPassword />} />
    </Route>
  </Routes>
);

export default LoginRoutes;
